import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  centerTextLeft: number | string;
  centerTextTop: number | string;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: (props) => ({
      position: "absolute",
      left: props.centerTextLeft,
      top: props.centerTextTop,
      width: 100,
      textAlign: "center",
    }),
    summaryValue: {
      height: 35,
      width: 40,
      margin: "auto",
      marginBottom: 4,
      marginTop: 4,
    },
    summaryLabel: {
      height: 20,
      width: 80,
      margin: "auto",
      marginBottom: 2,
      marginTop: 2,
    },
    summaryType: {
      height: 20,
      width: 80,
      margin: "auto",
      marginBottom: 2,
      marginTop: 2,
    },
  })
);

export default useStyles;
